import { Drawer } from '@navi/web-ui/lib/primitives';
import { IFeedback, IViewAllFeedbacksDrawerProps } from '../interfaces';
import FeedbackDetailsList from './FeedbackDetailsList';
import { logError } from '@cp/src/utils/ApiHelper';
import { useEffect, useState } from 'react';
import { getPastFeedbacksOnAddresses } from '../../../actions/topAddressesActions';
import { useParams } from 'react-router-dom';

const ViewAllFeedbacksDrawer = (props: IViewAllFeedbacksDrawerProps) => {
  const { isDrawerOpen, onClose, addressLine, relatedLocationIds } = props;
  const [feedbackList, setFeedbackList] = useState<IFeedback[]>([]);
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const { loanId = '' } = useParams();

  useEffect(() => {
    if (isDrawerOpen) {
      setIsFeedbackLoading(true);
      getPastFeedbacksOnAddresses({
        loanAccountNumber: loanId,
        addressReferenceIds: relatedLocationIds?.join(',') || ''
      })
        .then(res => {
          if (res?.data) {
            setFeedbackList(res.data || []);
          }
        })
        .catch(err => {
          logError(err);
        })
        .finally(() => {
          setIsFeedbackLoading(false);
        });
    }
  }, [isDrawerOpen]);
  return (
    <Drawer
      open={isDrawerOpen}
      headerContainerClasses="text-[var(--grayscale-content-2)]"
      headerText="Old feedbacks"
      showHeaderDivider={true}
      usePadding={false}
      contentClasses="overflow-auto"
      onClose={onClose}
      onOutSideClick={onClose}
      className="!w-[380px]"
      disableOutsideClick={false}
    >
      <FeedbackDetailsList
        addressText={addressLine}
        feedbackList={feedbackList}
        showLoader={isFeedbackLoading}
      />
    </Drawer>
  );
};

export default ViewAllFeedbacksDrawer;
